import React from 'react';

interface Student {
  name: string;
  favoriteQuote: string;
  favoriteSong: string;
  photo: string;
  githubLink?: string;
  linkedinLink?: string;
}

// 1. Atualize as props para incluir 'onClick'
interface StudentCardProps {
  student: Student;
  onClick: () => void;
}

const StudentCard: React.FC<StudentCardProps> = ({ student, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="bg-gray-900 rounded-2xl overflow-hidden shadow-lg transition-transform hover:scale-105 text-center p-6 fade-in flex flex-col justify-start items-center cursor-pointer border border-gray-800 w-full"
    >
      <img
        src={student.photo}
        alt={`Foto de ${student.name}`}
        className="w-36 h-36 md:w-40 md:h-40 rounded-full object-cover mb-4 border-4 border-gold shadow-md"
        loading="lazy"
      />
      <h2 className="text-lg md:text-xl font-bold text-gold mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{student.name}</h2>
      
      {/* NOVO: Div para os links sociais, adicionada logo abaixo do nome */}
      <div className="flex justify-center gap-6 mb-3"> 
        {/* LinkedIn Icon */}
        {student.linkedinLink && (
            <a 
                href={student.linkedinLink} 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()} // IMPEDE que o clique no link abra o Modal
                // ESTILO AINDA MAIS CLARO: Cor de base dourada mais forte, escala e brilho no hover
                className="text-gold/80 hover:text-white hover:bg-[#0A66C2] w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
                aria-label={`LinkedIn de ${student.name}`}
            >
                <i className="fab fa-linkedin-in text-2xl"></i>
            </a>
        )}
        {/* GitHub Icon */}
        {student.githubLink && (
            <a 
                href={student.githubLink} 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()} // IMPEDE que o clique no link abra o Modal
                // ESTILO AINDA MAIS CLARO: Cor de base dourada mais forte, escala e brilho no hover
                className="text-gold/80 hover:text-white hover:bg-[#6e5494] w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
                aria-label={`GitHub de ${student.name}`}
            >
                <i className="fab fa-github text-2xl"></i>
            </a>
        )}
      </div>

      <p className="text-white italic text-sm md:text-base mb-2 text-center px-2">"{student.favoriteQuote}"</p>
      <p className="text-xs md:text-sm text-white/60 text-center">🎵 {student.favoriteSong}</p>
    </div>
  );
};

export default StudentCard;